export default {
      id: "insurance-policy-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#insurance-policy",
      toString: function () {
        return this.url;
      }
    }